import Icon from '@/components/ui/AppIcon';

interface Metric {
  phase: string;
  category: string;
  metrics: string[];
  icon: string;
}

interface SuccessMetricsProps {
  metrics: Metric[];
}

const SuccessMetrics = ({ metrics }: SuccessMetricsProps) => {
  return (
    <div className="bg-card border border-border rounded-lg p-5 sm:p-6 lg:p-8 institutional-shadow">
      <div className="mb-6 sm:mb-8">
        <h3 className="text-xl sm:text-2xl font-semibold text-text-primary mb-2">Success Metrics & Evaluation</h3>
        <p className="text-sm sm:text-base text-text-secondary">
          Clear evaluation criteria ensure accountability and measure progress throughout each phase of engagement.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
        {metrics.map((metric, index) => (
          <div key={index} className="bg-surface border border-border rounded-lg p-4 sm:p-6">
            <div className="flex items-start space-x-3 sm:space-x-4 mb-3 sm:mb-4">
              <div className="flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 bg-institutional/10 rounded-lg flex-shrink-0">
                <Icon name={metric.icon as any} size={18} variant="outline" className="text-institutional" />
              </div>
              <div>
                <p className="text-xs font-semibold text-institutional mb-1">{metric.phase}</p>
                <h4 className="text-base sm:text-lg font-semibold text-text-primary">{metric.category}</h4>
              </div>
            </div>

            <ul className="space-y-1.5 sm:space-y-2">
              {metric.metrics.map((item, idx) => (
                <li key={idx} className="flex items-start space-x-2">
                  <Icon name="ChartBarIcon" size={14} variant="outline" className="text-success mt-1 flex-shrink-0" />
                  <span className="text-xs sm:text-sm text-text-secondary">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SuccessMetrics;